import type { CanvassHouse } from "@/canvasses/types";
import { computed, toValue, type Ref } from "vue";

export function useTurfFilter(
  canvassHouses: Ref<Array<CanvassHouse> | undefined>,
  selectedTurfId: Ref<string | null>,
) {
  const turfIds = computed(() => {
    if (canvassHouses.value === undefined) return [];

    const ids = new Set(
      toValue(canvassHouses.value)
        .map(({ turfId }) => turfId)
        .filter((turfId) => turfId !== undefined && turfId !== null),
    );
    return Array.from(ids).sort();
  });

  const filteredCanvassHouses = computed(() => {
    if (canvassHouses.value === undefined) return [];

    if (selectedTurfId.value === null) {
      return canvassHouses.value;
    } else {
      return canvassHouses.value.filter(
        ({ turfId }) => turfId === selectedTurfId.value,
      );
    }
  });

  return { turfIds, filteredCanvassHouses };
}
